import * as yup from "yup";

const DescribeSmiSchema = yup.object().shape({
  date: yup
    .date()
    .required("Date is required")
    .typeError("Enter valid date")
    .max(new Date(), "Enter valid date"),
  age: yup
    .number()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? undefined : value
    )
    .required("Age is required")
    .typeError("Enter valid age")
    .integer("Enter valid age")
    .min(0, "Enter valid age")
    .max(120, "Enter valid age"),
  describeEvent: yup.string().required("Description required"),
  formalDiagnosis: yup
    .string()
    .nullable()
    .oneOf(
      ["yes", "no", "idk"],
      "Please select whether a formal diagnosis has been made."
    )
    .required("Please select whether a formal diagnosis has been made."),
});

export default DescribeSmiSchema;